<h1 class="title" mat-dialog-title>Personeel van voorgaande dag</h1>
<div mat-dialog-content>
    @if (allExcludedBecauseAlreadyHours) {
        <div class="empty-state">
            Alle medewerkers van de voorgaande dag zijn uitgesloten omdat zij op deze dag al uren hebben geregistreerd.
        </div>
    } @else if (staffList?.length === 0) {
        <div class="empty-state">Er zijn geen medewerkers die overgenomen kunnen worden van de voorgaande dag.</div>
    } @else if (!staffList) {
        <div class="loading-state">Laden...</div>
    }
    @if (staffList?.length) {
        <div class="hourtype-select mb-3">
            <label class="select-label">Uursoort</label>
            <ng-select
                [items]="hourtypeOptions"
                [formControl]="fcHourtype"
                [clearable]="false"
                [searchable]="false"
                appendTo="body">
                <ng-template ng-label-tmp ng-option-tmp let-item="item">{{ item | hourtype }}</ng-template>
            </ng-select>
        </div>

        <div class="staff-list-label">
            <label class="select-label">Medewerkers</label>
        </div>
        <mat-selection-list [formControl]="fcUsers">
            @for (user of staffList; track user) {
                <mat-list-option [value]="user">
                    <div mat-line>{{ user.name }}</div>
                </mat-list-option>
            }
        </mat-selection-list>
    }
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Annuleren</button>
    <div class="spacer"></div>
    <button [disabled]="!fcUsers.value?.length" (click)="take()" mat-raised-button cdkFocusInitial color="primary">
        Overnemen
    </button>
</div>
